import { Component, effect, input, signal } from '@angular/core';
import { TranslatePipe } from '@cmi/addin-core';
import { getTableOptionsData, updateTableOptionsTag } from '../../../lib/word-content-controls';

@Component({
  selector: 'cmi-table-options',
  imports: [TranslatePipe],
  templateUrl: './table-options.html'
})
export class TableOptions {
  public readonly contentControlId = input.required<number>();

  protected readonly title = signal<string>('');
  protected readonly tag = signal<string>('');
  protected readonly selectionMode = signal<'withSelection' | 'withoutSelection'>('withSelection');
  protected readonly isApplying = signal<boolean>(false);
  protected readonly isExpanded = signal<boolean>(true);

  constructor() {
    // Load data when content control ID changes
    effect(() => {
      const id = this.contentControlId();
      if (id) {
        void this._loadData(id);
      }
    });
  }

  private async _loadData(contentControlId: number): Promise<void> {
    const data = await getTableOptionsData(contentControlId);
    if (data) {
      this.title.set(data.displayTitle);
      this.tag.set(data.tag);
      this.selectionMode.set(data.selectionMode);
    }
  }

  protected setSelectionMode(mode: 'withSelection' | 'withoutSelection'): void {
    this.selectionMode.set(mode);
  }

  protected toggleExpanded(): void {
    this.isExpanded.update((expanded) => !expanded);
  }

  protected async onApply(): Promise<void> {
    const id = this.contentControlId();
    if (!id) {
      return;
    }

    this.isApplying.set(true);

    try {
      const newTag = await updateTableOptionsTag(id, this.selectionMode());
      if (newTag !== null) {
        this.tag.set(newTag);
      }
    } finally {
      this.isApplying.set(false);
    }
  }
}
